export default "__VITE_ASSET__CguRhSKN__"